import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import MessageDialog from 'src/components/MessageDialog';
import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import * as Scenario from '../scenario/loginSsosp';

interface IRouteParams {
	company_code: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

/**
 * ログイン画面用コンポーネント
 */
class LoginSsosp extends React.Component<IProps> {
	public componentDidMount() {
		let companyCode = '';
		if (this.props.match && this.props.match.params) {
			companyCode = this.props.match.params.company_code;
		}
		this.props.fetch(companyCode);
	}

	/**
	 * 画面描画処理
	 */
	public render() {
		return (
			<div>
				<Progress open={this.props.isShowProgress} />
				<MessageDialog
					open={this.props.message.open}
					contents={this.props.message.messages}
					title={this.props.message.title}
					showCancelButton={false}
					onClickOk={this.handleDummy}
					onClose={this.handleDummy}
					messageNs="loginmessage"
				/>
			</div>
		);
	}

	// tslint:disable-next-line:no-empty
	protected handleDummy = () => {};
}

const mapStateToProps = (state: IRootState) => ({
	isShowProgress: state.login.isShowProgress,
	message: state.message,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetch: (companyCode: string) => Scenario.fetch(dispatch, companyCode),
});

// tslint:disable-next-line: no-empty-interface
export interface ILoginSsospProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ILoginSsospProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LoginSsosp);

const Export: React.ComponentType<ILoginSsospProps> = Connected;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/LoginSsosp.tsx